export const SUCCESSFULLY_LOGIN = "SUCCESSFULLY_LOGIN";
export const LOGOUT = "LOGOUT";
